import React, { useEffect, useState } from 'react'
import Select from "react-select";

import Breadcrumb from '../Breadcrumb/Breadcrumb';
import { downloadExcel1, getPermissionDetails, stringLimit } from '../../util/fn';
import useRequest from '../../hooks/useRequest';
import axios from 'axios';
import { BASEURL } from '../../constant/api';
import { toast } from 'react-toastify';
import BarChart from './BarChart';
import LineGraph from './LineGraph';

function Commission() {
  const { request: requestCities, response: responseCities } = useRequest();
  const [cities, setCities] = useState([]);
  const [city, setCity] = useState('');
  const [Dates, setDates] = useState([]);
  const [Dates1, setDates1] = useState([]);
  const [Dates2, setDates2] = useState([]);
  const [Dates3, setDates3] = useState([]);
  const [area, setArea] = useState('');
  const [seriesData, setSeriesData] = useState([{ name: "Commission Area Wise", data: [''] }]);
  const [seriesData1, setSeriesData1] = useState([{ name: "Commission City Wise", data: [''] }]);
  const [seriesData2, setSeriesData2] = useState([{ name: "Commission City Wise", data: [''] }]);
  const [seriesData3, setSeriesData3] = useState([{ name: "Commission City Wise", data: [''] }]);
  const [startDate, setStartDate] = useState(
    ''
  );
  const [endDate, setEndDate] = useState('');
  const { request: request, response: response } = useRequest();
  const [permissions, setPermissions] = useState([])
  const [data, setData] = useState('')
  const perPage = 10;
  const [totalDocuments, setTotalDocuments] = useState(10);
  const [page, setPage] = useState(1);

  const [startIndex, setStartIndex] = useState(1);

  useEffect(() => {
    requestCities("GET", "admin/vendor/getCity");
  }, []);

  useEffect(() => {
    const todayDate = new Date();
    todayDate.setDate(todayDate.getDate() - 15);
    setStartDate(todayDate.toISOString().split('T')[0]);

    todayDate.setDate(todayDate.getDate() + 15);
    setEndDate(todayDate.toISOString().split('T')[0]);
    GetData()
  }, [startDate, endDate]);
  useEffect(() => {
    if (responseCities) {
      if (responseCities.status && responseCities.data) {
        setCities(responseCities.data);

      }
    }
  }, [responseCities]);

  const DownloadExcel = async () => {


    const data = {
      city: city,
      area: area,
      startDate: startDate,
      endDate: endDate,
      isExcelDownload: true

    }
    const config = {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': "Bearer " + localStorage.getItem("token")
      }
    };

    try {
      const response = await axios.post(`${BASEURL.PORT}/admin/report/commissionReport`, data, config);
      if (response?.data?.status == true) {
        let Ranking = response?.data?.data?.commissionAreaWise?.map((obj, index) => ({
          'Sr.': index + 1,
          'outlet': obj?.outlet,
          'Commission': obj?.commission,

        }));
        let CityWise = response?.data?.data?.commissionCityWise?.map((obj, index) => ({
          'Sr.': index + 1,
          'outlet': obj?.outlet,
          'Commission': obj?.commission,

        }));


        const dataArray = [Ranking, CityWise];
        const namesArray = ["Commission Area Wise Report", 'Commission City Wise Report'];
        const headingsArray = [null, null]; // Assuming no headers for the data

        downloadExcel1(dataArray, namesArray, headingsArray);
      }

    } catch (error) {
      toast.error(error.message)
    }

  }

  const GetData = async () => {
    const data = {
      city: city,
      area: area,
      startDate: startDate,
      endDate: endDate
    }
    const config = {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': "Bearer " + localStorage.getItem("token")
      }
    };

    try {
      const response = await axios.post(`${BASEURL.PORT}/admin/report/commissionReport`, data, config);
      if (response?.data?.status == true) {
        setData(response?.data?.data)
        setDates(response?.data?.data?.commissionAreaWise?.map((val) => (
          val.outlet
        )))
        setDates1(response?.data?.data?.commissionCityWise?.map((val) => (
          val.outlet
        )))
        setDates2(response?.data?.data?.averageCommissionCity?.map((val) => (
          val.city
        )))
        setDates3(response?.data?.data?.averageCommissionLocation?.map((val) => (
          val.area
        )))


        const dataa = response?.data?.data?.commissionAreaWise?.map((val) => (
          parseInt(val.commission)
        ))

        const dataa1 = response?.data?.data?.commissionCityWise?.map((val) => (
          parseInt(val.commission)
        ))
        const dataa2 = response?.data?.data?.averageCommissionCity?.map((val) => (
          parseInt(val.average)
        ))
        const dataa3 = response?.data?.data?.averageCommissionLocation?.map((val) => (
          parseInt(val.average)
        ))
        setSeriesData(
          { name: "Commission Area Wise", data: [...dataa] }
        );
        setSeriesData1(
          { name: "Commission City Wise", data: [...dataa1] }
        )
        setSeriesData2(
          { name: "Average Commission Status - City Wise", data: [...dataa2] }
        );
        setSeriesData3(
          { name: "Average Commission Status - Location Wise", data: [...dataa3] }
        )
      }

    } catch (error) {
      toast.error(error.message)
    }
  }


  return (
    <div>

      <div className="ms-content-wrapper">
        <div className="row">
          <div className="col-md-12">
            <Breadcrumb
              title={"Commission Report"}
              links={[{ to: "/", name: "Home" }]}
            />
            <div className="ms-panel">
              <div className="ms-panel-header">
                <div className="row">
                  <div className="col-md-3">
                    <h6>{"Commission Report"}</h6>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-2">
                    <div className="form-group">
                      <label htmlFor="cities">From Date:</label>
                      <input type='date'
                        value={startDate}
                        className='form-control'

                        onChange={(e) => {
                          // Calculate end date as 15 days from the start date
                          const endDate = new Date(e.target.value);
                          endDate.setDate(endDate.getDate() + 15);
                          setEndDate(endDate.toISOString().split('T')[0]);
                          setStartDate(e.target.value)
                        }
                        }
                      />
                    </div>
                  </div>
                  <div className="col-md-2">

                    <div className="form-group">
                      <label htmlFor="cities">To Date:</label>
                      <input type='date'
                        className='form-control'
                        value={endDate}
                        disabled
                        onChange={(e) => setEndDate(e.target.value)} />
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="form-group">
                      <label htmlFor="cities">Area:</label>
                      <input type='text'
                        className='form-control'
                        value={area}

                        onChange={(e) => setArea(e.target.value)} />
                    </div>
                  </div>

                  <div className="col-md-2">

                    <div className="form-group">
                      <label htmlFor="cities">City:</label>
                      <Select
                        options={
                          cities &&
                          cities.length > 0 &&
                          cities.map((obj) => ({
                            label: obj.name,
                            value: obj._id,
                          }))
                        }
                        name="cities"
                        onChange={(value) => {
                          setCity(value.value)
                        }}
                      />
                    </div>
                  </div>

                  <div className="col-md-2">
                    <div className='d-flex'>
                      <button className="mx-3 btn btn-primary burron" onClick={DownloadExcel}>Download Excel</button>
                      <button className="mx-3 btn btn-primary burron" onClick={GetData}>Filter</button>
                    </div>

                  </div>
                </div>



              </div>

              <div className='row mt-4'>
                <div className='col-md-4'></div>
                <div className='col-md-6'>
                  <div><h5>Commission Status - Area Wise</h5></div>
                </div>
              </div>
              <div className="row">
                <div className='col-md-6'>
                  <div className="ms-panel-body">
                    <div className="table-responsive">
                      <table className="table table-hover thead-primary">
                        <thead>
                          <tr>

                            <th scope="col">OutletLet</th>
                            <th scope="col">Commission %</th>
                          </tr>
                        </thead>
                        <tbody>
                          {
                            data?.commissionAreaWise?.length > 0 &&
                            data?.commissionAreaWise?.map((item, i) => (
                              <tr key={item._id}>

                                <td>{item.outlet}</td>
                                <td>{item.commission}</td>

                              </tr>
                            ))}
                          {data.length == 0 && (
                            <tr>
                              <td colspan="10" style={{ textAlign: "center" }}>
                                {" "}
                                No Data Found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div className='col-md-6'>
                  <LineGraph title='Commission Area Wise' series={seriesData} categories={Dates} />
                </div>
              </div>
              <div className='row'>
                <div className='col-md-4'></div>
                <div className='col-md-6'>
                  <div><h5>Commission Status - City Wise</h5></div>
                </div>
              </div>
              <div className="row">
                <div className='col-md-6'>
                  <div className="ms-panel-body">
                    <div className="table-responsive">
                      <table className="table table-hover thead-primary">
                        <thead>
                          <tr>

                            <th scope="col">OutletLet</th>
                            <th scope="col">Commission %</th>
                          </tr>
                        </thead>
                        <tbody>
                          {
                            data?.commissionCityWise?.length > 0 &&
                            data?.commissionCityWise?.map((item, i) => (
                              <tr key={item._id}>

                                <td>{item.outlet}</td>
                                <td>{item.commission}</td>

                              </tr>
                            ))}
                          {data?.commissionCityWise?.length == 0 && (
                            <tr>
                              <td colspan="10" style={{ textAlign: "center" }}>
                                {" "}
                                No Data Found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div className='col-md-6'>
                  <BarChart title='Commission City Wise' series={seriesData1} categories={Dates1} />

                </div>
              </div>



              <div className='row'>
                <div className='col-md-4'></div>
                <div className='col-md-6'>
                  <div><h5>Average Commission Status - Location Wise</h5></div>
                </div>
              </div>
              <div className="row">
                <div className='col-md-6'>
                  <div className="ms-panel-body">
                    <div className="table-responsive">
                      <table className="table table-hover thead-primary">
                        <thead>
                          <tr>

                            <th scope="col">Area</th>
                            <th scope="col">Average</th>
                          </tr>
                        </thead>
                        <tbody>
                          {
                            data?.averageCommissionLocation?.length > 0 &&
                            data?.averageCommissionLocation.map((item, i) => (
                              <tr key={item._id}>

                                <td>{item.area}</td>
                                <td>{item.average}</td>

                              </tr>
                            ))}
                          {data?.averageCommissionLocation?.length == 0 && (
                            <tr>
                              <td colspan="10" style={{ textAlign: "center" }}>
                                {" "}
                                No Data Found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div className='col-md-6'>
                <LineGraph title='Average Commission Status - Location Wise' series={seriesData3} categories={Dates3} />

                </div>
              </div>

              <div className='row'>
                <div className='col-md-4'></div>
                <div className='col-md-6'>
                  <div><h5>Average Commission Status - City Wise</h5></div>
                </div>
              </div>
              <div className="row">
                <div className='col-md-6'>
                  <div className="ms-panel-body">
                    <div className="table-responsive">
                      <table className="table table-hover thead-primary">
                        <thead>
                          <tr>

                            <th scope="col">City</th>
                            <th scope="col">Average</th>
                          </tr>
                        </thead>
                        <tbody>
                          {
                            data?.averageCommissionCity?.length > 0 &&
                            data?.averageCommissionCity?.map((item, i) => (
                              <tr key={item._id}>

                                <td>{item.city}</td>
                                <td>{item.average}</td>

                              </tr>
                            ))}
                          {data?.averageCommissionCity?.length == 0 && (
                            <tr>
                              <td colspan="10" style={{ textAlign: "center" }}>
                                {" "}
                                No Data Found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div className='col-md-6'>
                <LineGraph title='Average Commission Status - City Wise' series={seriesData2} categories={Dates2} />

                </div>
              </div>


            </div>

          </div>
          {/* <div className="col-md-12">
            {perPage !== 0 &&
              data.length != totalDocuments &&
              data.length != 0 && (
                <Pagination
                  page={page}
                  totalDocuments={totalDocuments}
                  getNewData={fetchMoreData}
                  perPage={perPage}
                  currentDocLength={data.length}
                />
              )}
          </div> */}
        </div>
      </div>
    </div>
  )
}

export default Commission